export function ggID() {
  let id = 0;
  return function genId() {
    return id++;
  };
}
export function timeout(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
export const noop = () => {};



// WEBPACK FOOTER //
// ./src/views/doc-in/components/pdf-lib-utils/helper.js